import { render, staticRenderFns } from "./listItems.component.html?vue&type=template&id=7105a0f0&scoped=true&"
import script from "./ListItems.vue?vue&type=script&lang=ts&"
export * from "./ListItems.vue?vue&type=script&lang=ts&"
import style0 from "./listItems.component.scss?vue&type=style&index=0&id=7105a0f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7105a0f0",
  null
  
)

export default component.exports